import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" fill="none" viewBox="0 0 22 18" className={className}>
    <path
      fill="#000"
      d="M17.596 17.93c-1.093 0-2.017-.378-2.772-1.133-.754-.754-1.132-1.678-1.132-2.771 0-1.094.378-2.017 1.132-2.772.755-.755 1.68-1.132 2.772-1.132 1.093 0 2.017.377 2.772 1.132.755.755 1.132 1.678 1.132 2.772 0 1.093-.377 2.017-1.132 2.771-.755.755-1.679 1.132-2.772 1.132zm-.001-1.75c.595 0 1.102-.21 1.523-.631.421-.42.632-.928.632-1.522 0-.595-.21-1.103-.63-1.524a2.072 2.072 0 00-1.523-.631c-.594 0-1.102.21-1.523.63-.421.42-.632.928-.632 1.522 0 .595.21 1.103.63 1.524.421.421.928.632 1.523.632zM2.25 14.9v-1.75h8.885v1.75H2.25zm2.154-7.022c-1.093 0-2.017-.377-2.772-1.132C.877 5.991.5 5.067.5 3.974c0-1.093.377-2.017 1.132-2.771C2.387.448 3.311.07 4.404.07c1.093 0 2.017.377 2.772 1.132.754.754 1.132 1.678 1.132 2.771S7.93 5.991 7.176 6.746c-.755.755-1.68 1.132-2.772 1.132zm-.001-1.75c.594 0 1.102-.21 1.523-.63.421-.42.632-.928.632-1.522 0-.595-.21-1.103-.63-1.524a2.072 2.072 0 00-1.523-.631c-.595 0-1.102.21-1.523.63-.421.42-.632.928-.632 1.522 0 .595.21 1.103.63 1.524.42.42.928.631 1.523.631zm6.462-1.279V3.1h8.885v1.75h-8.885z"
    ></path>
  </svg>
);

export default Icon;
